(() => {
  const PENDING_KEY = 'tca_newsletter_signup_pending';
  const SENT_PREFIX = 'tca_newsletter_signup_sent:';
  const MAX_PENDING_AGE = 30 * 60 * 1000;
  const validPlacements = new Set(['homepage', 'footer']);
  const forms = [...document.querySelectorAll('#TcaNewsletterHomepage, #TcaNewsletterFooter')];

  const readPending = () => {
    try {
      return JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
    } catch (error) {
      return null;
    }
  };

  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (form.dataset.tcaSubmitting === 'true') {
        event.preventDefault();
        return;
      }

      const placement = form.querySelector('[data-tca-newsletter-placement]')?.value;
      if (!validPlacements.has(placement)) return;

      const id = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify({
          id,
          submitted_at: Date.now(),
          placement
        }));
      } catch (error) {}

      form.dataset.tcaSubmitting = 'true';
      const button = form.querySelector('[data-tca-newsletter-submit]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.tcaOriginalLabel = button.innerHTML;
        button.textContent = 'Joining…';
      }
    });
  });

  const successes = [...document.querySelectorAll('[data-tca-newsletter-success]')];
  if (!successes.length) return;

  const pending = readPending();
  const submittedAt = Number(pending?.submitted_at || 0);
  const age = Date.now() - submittedAt;
  const pendingIsRecent = Boolean(
    pending?.id &&
    validPlacements.has(pending?.placement) &&
    Number.isFinite(submittedAt) &&
    submittedAt > 0 &&
    age >= 0 &&
    age <= MAX_PENDING_AGE
  );

  if (!pendingIsRecent) {
    if (pending && (age < 0 || age > MAX_PENDING_AGE)) {
      try { sessionStorage.removeItem(PENDING_KEY); } catch (error) {}
    }
    return;
  }

  const matchingSuccess = successes.find((node) => node.dataset.tcaNewsletterSuccess === pending.placement);
  if (!matchingSuccess) return;
  matchingSuccess.focus();

  const sentKey = `${SENT_PREFIX}${pending.id}`;
  try {
    if (sessionStorage.getItem(sentKey)) return;
    sessionStorage.setItem(sentKey, '1');
  } catch (error) {
    if (matchingSuccess.dataset.eventPublished === 'true') return;
    matchingSuccess.dataset.eventPublished = 'true';
  }

  const payload = {
    event_id: pending.id,
    method: 'newsletter',
    placement: pending.placement
  };
  window.Shopify?.analytics?.publish?.('tca_newsletter_signup', payload);
  window.dispatchEvent(new CustomEvent('tca_newsletter_signup', { detail: payload }));
  try { sessionStorage.removeItem(PENDING_KEY); } catch (error) {}
})();
